(function() {
    let jQueryCheckAttempts = 0;
    const maxJQueryCheckAttempts = 100, checkInterval = 100;

    function initVideoPlayTracking() {
        const $delegationTarget = $(document);

        function getProductName() {
            let productName = "Product Video Play"; // Default
            const $productTitleElement = $('.product__title > h1').first();
            if ($productTitleElement.length && $productTitleElement.text().trim() !== '') {
                productName = $productTitleElement.text().trim();
            }
            return productName;
        }

        // Combine selectors for efficiency, use namespacing for .off()
        $delegationTarget.off('click.ga4VideoTracking').on('click.ga4VideoTracking',
            'button.deferred-media__poster[id^="Deferred-Poster-Modal-"], button[aria-label^="Play video"]',
            function() {
                const $button = $(this);
                const mediaIdAttribute = $button.closest('li[data-media-id]').data('media-id') || $button.data('media-id');
                const itemId = 'video_' + (mediaIdAttribute || 'gallery_item');
                const itemName = getProductName();

                // --- UPDATED: PUSH TO DATA LAYER FOR GTM ---
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'Play_Video',
                    'content_type': 'product_video',
                    'item_id': itemId,
                    'item_name': itemName
                });
                // Optional: Check browser console to confirm it fired
                console.log("Video Play Event Pushed to GTM:", itemName); 
                // --- END UPDATE ---
            }
        );
    }

    function ensureJQueryAndDomReady() {
        if (window.jQuery && typeof window.jQuery === 'function') {
            $(initVideoPlayTracking); // jQuery's DOM ready
        } else {
            jQueryCheckAttempts++;
            if (jQueryCheckAttempts < maxJQueryCheckAttempts) {
                setTimeout(ensureJQueryAndDomReady, checkInterval);
            } else {
                console.error('GA4 VIDEO TRACKING ERROR: jQuery failed to load. Video tracking script will not run.');
            }
        }
    }
    ensureJQueryAndDomReady();
})();